enum MaritalStatusEnum {
    DeFacto = 'DEFACTO',
    Divorced = 'DIVORCED',
    Married = 'MARRIED',
    Separated = 'SEPARATED',
    Single = 'SINGLE',
}

export default MaritalStatusEnum;
